import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import { getDelegateSeminarDetails_action, insertUpdateDelegateSeminar_action } from "../../../actions/delegate_module_action/delegate_seminar_action/delegate_seminar_action";
import { toastError, seminarInterestActionId, toastSuccess } from "../../../utils/constants";
import { data } from "jquery";
import moment from "moment";
import { fill_action } from "../../../actions/fillCombo_action";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import DelegateTopMenu from "../../../common_components/delegate_module_topmenu";
import DelegateDrawer from "../../../common_components/delegate_module_drawer";
const { Component } = require("react");

class DelegateSeminar extends Component {

    // Intialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            SeminarList: []
        }
    }

    // On componet Load
    componentDidMount() {
        this.getFillList(seminarInterestActionId, '', '', '1', '');
        setTimeout(() => {
            this.getDelegateSeminarDetails()
        }, 1000);
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value) {
        const { isAdd } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === seminarInterestActionId) {
                        data.data.sort((a, b) => a.SeqNo - b.SeqNo);
                        data.data.length > 0 && data.data.map((item) => {
                            if (item.ParentSeminarID != null) {
                                item.Day = ''
                            }
                        })
                        const result = this.calculateRowspan(data.data);
                        this.setState({
                            SeminarList: result,
                            isLoading: false
                        })

                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    calculateRowspan(data) {
        // Create a map to count children for each parent seminar
        const parentChildMap = {};

        // Initialize Rowspan for each item and count the children
        data.forEach(item => {
            item.Rowspan = 0; // Default Rowspan for all items

            if (item.ParentSeminarID !== null) {
                // Increment child count for the parent
                parentChildMap[item.ParentSeminarID] = (parentChildMap[item.ParentSeminarID] || 0) + 1;
            }
        });

        // Assign Rowspan to parent seminars
        data.forEach(item => {
            if (item.ParentSeminarID === null) {
                // If it's a parent, Rowspan is itself plus its children
                item.Rowspan = (parentChildMap[item.SeminarID] || 0) + 1;
            }
        });

        return data;
    }

    getDelegateSeminarDetails() {
        const { SeminarList } = this.state
        this.setState({ isLoading: true })
        this.props.getDelegateSeminarDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        const result = SeminarList.map(item => ({
                            ...item,
                            IsSelect: data.data.some(item2 => item2.SeminarID === item.SeminarID) ? 1 : 0,

                        }))
                        console.log("result----->", result)
                        this.setState({ SeminarList: result });

                    }
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateDelegateSeminar() {
        const { SeminarList } = this.state
        const array = []
        SeminarList.map(data => {
            if (data.IsSelect) {
                array.push({ SeminarID: data.SeminarID })
            }
        })
        this.setState({ isLoading: true })
        this.props.insertUpdateDelegateSeminar_action(array)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Data Updated Successfully!")
                    this.getDelegateSeminarDetails()
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onCheked(event, index) {

        const { SeminarList } = this.state
        SeminarList.forEach((data, i) => {
            if (i === index) {
                data.IsSelect = event
            }
        })
        this.setState({ SeminarList: SeminarList })
    }

    render() {
        const { isLoading, SeminarList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <VisitorHeader2 />
                <DelegateDrawer />
                <div className="main-content with-dr-container">
                    <div className="">
                        <div className="">
                            <DelegateTopMenu />
                        </div>
                        <div className="row">
                            <div className="col-xl-12 p-0">
                                <div className="card rounded-0 pt-1">
                                    <div className="card-header p-3">
                                        <h3 className="card-title">Delegate Seminar</h3>
                                    </div>
                                    <div className="card-body p-4">
                                        <div className="table-responsive mb-2">
                                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center">Day</th>
                                                        <th style={{ width: '180px' }}>Date & Time</th>
                                                        <th style={{ width: '680px' }}>Description</th>
                                                        <th style={{ width: '380px' }}>Speaker</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        SeminarList.length > 0 && SeminarList.map((data, index) => (
                                                            <>
                                                                {data.ParentSeminarID == 0 || data.ParentSeminarID == null && <tr >
                                                                    <td style={{ borderRight: 'none' }}></td>
                                                                    <td style={{ border: 'none' }}></td>
                                                                    <td style={{ border: 'none' }}></td>
                                                                    <td style={{ border: 'none' }}></td>
                                                                    <td style={{ borderLeft: 'none' }}></td>
                                                                </tr>}
                                                                <tr key={Math.random()}>
                                                                    {data.ParentSeminarID == 0 || data.ParentSeminarID == null ?
                                                                        <td className={"fw-bold"} rowSpan={data.Rowspan} style={{ verticalAlign: 'middle', textAlign: 'center' }}>{data.Day}</td>
                                                                        : <></>}
                                                                    <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.DateTime}</td>
                                                                    {data.ParentSeminarID != 0 && data.ParentSeminarID != null ?
                                                                        <>
                                                                            <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Description}</td>
                                                                            {data.SeminarID != 14 ? (
                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker}</td>
                                                                            ) : (
                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker.split('==').map(item => (
                                                                                    <tr className="text-start">{item}</tr>
                                                                                ))}</td>
                                                                            )}
                                                                        </> :
                                                                        <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ verticalAlign: 'middle', textAlign: 'center' }} colSpan={2}>{data.Description}</td>}

                                                                    <td className="text-center" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                                        {data.ParentSeminarID != 0 && data.ParentSeminarID != null &&
                                                                            <input type="checkbox"
                                                                                value={data.IsSelect}
                                                                                checked={data.IsSelect}
                                                                                onChange={(e) => this.onCheked(e.target.checked, index)}
                                                                            />
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-primary rounded-0 mt2"
                                            style={{ marginRight: 10, float: 'right', marginTop: '10px' }}
                                            onClick={() => this.insertUpdateDelegateSeminar()}
                                            disabled={SeminarList.length == 0}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getDelegateSeminarDetails_action, insertUpdateDelegateSeminar_action })(DelegateSeminar))